import { createApp } from 'vue';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import PatientRegistration from './components/PatientRegistration/PatientRegistration.vue';
import AiConfigurator from './components/AiConfigurator/AiConfigurator.vue';
import AiConfiguratorShopPopup from './components/AiConfigurator/AiConfiguratorShopPopup.vue';

const mountPoints = document.querySelectorAll('.js-vue-root');
if (mountPoints.length) {
    mountPoints.forEach((mountPoint) => {
        const app = createApp({});
        app.component('patientregistration', PatientRegistration);
        app.component('verenzaaiconfigurator', AiConfigurator);
        app.component('verenzaaiconfiguratorshop', AiConfiguratorShopPopup);

        app.use(PerfectScrollbarPlugin);

        app.mount(mountPoint);
    });
}
